import { ReactNode } from "react";
import { cn } from "../ui/utils";

export default function AnimatedGradientText({
    children,
    className,
    ...props
}: {
    children: ReactNode;
    className?: string;
} & React.HTMLAttributes<HTMLDivElement>) {
    return (
        <div
            className={cn(
                "group relative flex flex-row items-center justify-center rounded-7xl px-4 py-1.5 text-sm shadow-[inset_0_-8px_10px_#8fdfff1f] backdrop-blur-sm transition-shadow duration-500 ease-out [--bg-size:300%] hover:shadow-[inset_0_-5px_10px_#8fdfff3f]",
                className,
            )}
            {...props}
        >
            <div
                className={`absolute inset-0 block h-full w-full animate-gradient bg-gradient-to-r from-[#1262d0] via-[#9c40ff] to-[#2dd4bf] bg-[length:var(--bg-size)_100%] p-[1px] ![mask-composite:subtract] [border-radius:inherit] [mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)]`}
            />

            {children}
        </div>
    );
}
